import React, { createContext, useContext, useState, useEffect } from "react";

const STRINGS = {
  da: {
    "nav.find_jobs": "Find jobs",
    "nav.post_job": "Opret job",
    "nav.dashboard": "Dashboard",
    "nav.my_jobs": "Mine jobs",
    "nav.admin": "Admin",
    "nav.login": "Log ind",
    "nav.register": "Tilmeld",
    "nav.logout": "Log ud",
    "nav.profile": "Min profil",
    "nav.edit_profile": "Rediger profil",
    "nav.home": "Hjem",
    "nav.find": "Find",
    "nav.create": "Opret",
    "nav.me": "Mig",
    "nav.jobs": "Jobs",
    "common.cancel": "Annuller",
    "common.save": "Gem",
    "common.delete": "Slet",
    "common.confirm": "Bekræft",
    "common.loading": "Indlæser...",
    "common.back": "Tilbage",
    "common.download_receipt": "Download kvittering",
    "common.notifications": "Notifikationer",
    "common.mark_all_read": "Markér alle som læst",
    "common.no_notifications": "Ingen notifikationer endnu",
    "lang.toggle": "EN",
  },
  en: {
    "nav.find_jobs": "Browse jobs",
    "nav.post_job": "Post job",
    "nav.dashboard": "Dashboard",
    "nav.my_jobs": "My jobs",
    "nav.admin": "Admin",
    "nav.login": "Log in",
    "nav.register": "Sign up",
    "nav.logout": "Log out",
    "nav.profile": "My profile",
    "nav.edit_profile": "Edit profile",
    "nav.home": "Home",
    "nav.find": "Browse",
    "nav.create": "Post",
    "nav.me": "Me",
    "nav.jobs": "Jobs",
    "common.cancel": "Cancel",
    "common.save": "Save",
    "common.delete": "Delete",
    "common.confirm": "Confirm",
    "common.loading": "Loading...",
    "common.back": "Back",
    "common.download_receipt": "Download receipt",
    "common.notifications": "Notifications",
    "common.mark_all_read": "Mark all read",
    "common.no_notifications": "No notifications yet",
    "lang.toggle": "DA",
  },
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("grabber_lang") || "da");
  useEffect(() => { localStorage.setItem("grabber_lang", lang); }, [lang]);
  const t = (key) => STRINGS[lang][key] || STRINGS.da[key] || key;
  const toggle = () => setLang(lang === "da" ? "en" : "da");
  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
